"use client";

import "@/components/shared/MapLink.css";

const MapLink = ({
  location,
  fullAddress = false,
  className,
  clickable = true,
  icon = true,
  showNotes = false,
  useIcon = "fa-location-pin"
}) => {

  const firstLabel = location => {
    if (
      location.locationSource === "GPS" ||
      location.locationSource === "MEDIA" ||
      location.locationSource === "EXTERNAL" ||
      location.locationSource === "USER"
    ) {
      return location.name;
    } else if (
      location.locationSource === "URALITY_PROFILE" ||
      location.locationSource === "GOOGLE" ||
      location.locationSource === "MAPBOX" ||
      location.locationSource === "URALITY"
    ) {
      return location.streetAddress ?? location.address;
    } else {
      return null;
    }
  };

  const secondLabel = (location) => {
    if (fullAddress) {
      if( location.locationSource === "URALITY_PROFILE") {
        return location.address;
      } else if( location.locationSource === "GOOGLE" || location.locationSource === "MAPBOX" ) {
        // Remove location.streetAddress from location.address if present
        return location.address && location.streetAddress
          ? location.address.replace(location.streetAddress, '').replace(/^,?\s*/, '')
          : location.address;

      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const label1 = firstLabel(location);
  const label2 = secondLabel(location);

  const getMapLink = (location) => {
    const encodedAddress = location.address 
      ? encodeURIComponent(location.address.replace(/\s/g, '+')) 
      : null;
  
    // Just use Google Maps as the universal link
    // It works on all platforms and redirects appropriately
    // on mobile devices
    return `https://www.google.com/maps/search/?api=1&query=${
      encodedAddress || `${location.latitude},${location.longitude}`
    }`;
  };

  const theLink = () => {
    const mapLink = getMapLink(location);
    if (clickable) {
      return (
        <a
          // className="style-as-div"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start"
          }}
          href={mapLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => e.stopPropagation()}
        >
          <div className="map-link with-icon">
            {icon && <i className={`fa-solid ${useIcon}`}></i>}
            <div className="text-stacked">
              {label1 && (
                <span className="location-name">{label1}</span>
              )}
              {showNotes && location.notes && (
                <span className="location-notes">{location.notes}</span>
              )}
            </div>
          </div>
        </a>
      );
    } else {
      return (
        <div className="map-link with-icon">
          {icon && <i className={`fa-solid ${useIcon}`}></i>}
          <div className="text-stacked">
            {label1 && (
              <span className="location-label">{label1}</span>
            )}
            {label2 && (
              <span className="text-muted">{label2}</span>
            )}
            {showNotes && location.notes && (
              <span className="location-notes">{location.notes}</span>
            )}
          </div>
        </div>
      );
    }
  };

  if (className) {
    return <div className={className}>{theLink()}</div>;
  } else {
    return <>{theLink()}</>;
  }
};
export default MapLink;
